import { Link } from 'react-router-dom';

const TennisPage = () => {
  return (
    <div className="min-h-screen bg-slate-950 flex items-center justify-center px-4 py-20">
      <div className="max-w-4xl w-full">
        {/* Main glass container */}
        <div className="relative bg-slate-900/40 backdrop-blur-sm border border-white/[0.08] rounded-lg p-8 md:p-12 hover:bg-slate-900/60 hover:border-white/[0.12] transition-all duration-200">

          {/* Live indicator */}
          <div className="absolute top-6 right-6">
            <span className="w-1.5 h-1.5 bg-emerald-500/70 rounded-full animate-pulse" />
          </div>

          {/* Terminal-style header */}
          <div className="mb-8 pb-6 border-b border-white/[0.05]">
            <h1 className="text-xs font-medium tracking-[0.3em] text-white/30 uppercase mb-2">
              Tennis Analytics Platform
            </h1>
            <p className="text-4xl md:text-5xl font-sans text-white/95 mb-4">
              Coming Soon
            </p>
            <div className="h-1 w-24 bg-gradient-to-r from-emerald-500/80 to-violet-500/80 rounded-full" />
          </div>

          {/* Content */}
          <div className="space-y-6 mb-8">
            <p className="text-sm text-white/70 leading-relaxed">
              Our AI-powered tennis analytics platform is currently in development.
              We're building sophisticated tools to deliver real-time insights,
              player performance metrics, and match predictions powered by advanced
              machine learning algorithms.
            </p>

            {/* Feature preview grid */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 py-6">
              <div className="bg-white/[0.02] backdrop-blur-sm border border-white/[0.05] rounded p-4">
                <span className="block text-[10px] text-white/30 uppercase tracking-wider mb-2">
                  Feature
                </span>
                <span className="text-sm text-white/70">
                  Live Match Analysis
                </span>
              </div>
              <div className="bg-white/[0.02] backdrop-blur-sm border border-white/[0.05] rounded p-4">
                <span className="block text-[10px] text-white/30 uppercase tracking-wider mb-2">
                  Feature
                </span>
                <span className="text-sm text-white/70">
                  Player Performance Metrics
                </span>
              </div>
              <div className="bg-white/[0.02] backdrop-blur-sm border border-white/[0.05] rounded p-4">
                <span className="block text-[10px] text-white/30 uppercase tracking-wider mb-2">
                  Feature
                </span>
                <span className="text-sm text-white/70">
                  AI-Powered Predictions
                </span>
              </div>
            </div>

            <p className="text-xs text-white/50">
              Stay tuned for updates as we prepare to launch this exciting new feature.
            </p>
          </div>

          {/* CTA Section */}
          <div className="flex flex-col sm:flex-row gap-4 pt-6 border-t border-white/[0.05]">
            <Link
              to="/home"
              className="px-8 py-3 bg-gradient-to-r from-emerald-500/80 to-violet-500/80 backdrop-blur-sm rounded-md text-white text-[11px] font-medium tracking-[0.15em] uppercase hover:from-emerald-500 hover:to-violet-500 transition-all duration-200 shadow-lg shadow-emerald-500/10 text-center"
            >
              Return to Home
            </Link>
            <button className="px-6 py-3 bg-white/[0.02] backdrop-blur-sm border border-violet-500/20 rounded-md text-[11px] text-white/70 uppercase tracking-wider hover:bg-white/[0.05] hover:border-violet-500/30 hover:text-violet-400/80 transition-all duration-200">
              Notify Me
            </button>
          </div>
        </div>

        {/* Sub info */}
        <div className="mt-6 text-center">
          <p className="text-[11px] text-white/30 uppercase tracking-wider">
            Premium AI Sports Analytics Platform
          </p>
        </div>
      </div>
    </div>
  );
};

export default TennisPage;
